var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "rgb(88, 106, 218)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3 7v-2c0-2.76142375 2.23857625-5 5-5 2.7614237 0 5 2.23857625 5 5v2h.5c.5522847 0 1 .44771525 1 1v6c0 1.1045695-.8954305 2-2 2h-9c-1.1045695 0-2-.8954305-2-2v-6c0-.55228475.44771525-1 1-1zm5 2.5c-.55228475 0-1 .44771525-1 1v2c0 .5522847.44771525 1 1 1s1-.4477153 1-1v-2c0-.55228475-.44771525-1-1-1zm3-2.5v-2c0-1.65685425-1.34314575-3-3-3s-3 1.34314575-3 3v2z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon-lock.29354517ecbb1619bd2ea4f43b1cd08e.svg";
export { ForwardRef as ReactComponent };